import { render, staticRenderFns } from "./AstroDetailsEdit.vue?vue&type=template&id=a4b72722"
import script from "./AstroDetailsEdit.vue?vue&type=script&lang=js"
export * from "./AstroDetailsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports